import { Product } from "./components/product";
import { Base } from "./products.base";

export const Products = Object.assign(Base, {
    Product
});
